const browser = require('detect-browser');

export class BrowserUtils {

    public static EDGE: string = "edge";
    public static CHROME: string = "chrome";
    public static FIREFOX: string = "firefox";
    public static OPERA: string = "opera";
    public static IE: string = "ie";
    public static ANDROID: string = "android";
    public static IOS: string = "ios";
    public static SAFARI: string = "safari";

    static isBrowser(name: string): boolean {
        return browser.name === name
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/utils/browser.utils.ts